import React, { useMemo } from 'react';
import skeleton from './styles.module.scss';
import styles from './../styles.module.scss';

export default function SkeletonMedalsCards() {
  const bannerArray = useMemo(
    () =>
      Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className={skeleton.banner} />
      )),
    [],
  );

  return (
    <div className={styles['container-medals']}>
      <div className={styles['container-medals__header']}>
        <div className={skeleton.text} />
        <div className={skeleton['container-link']}>
          <div className={skeleton.text} />
          <div className={skeleton.chevron} />
        </div>
      </div>
      <div>
        <div className={skeleton['container-link']}>{bannerArray}</div>
      </div>
    </div>
  );
}
